import React from "react";

function Hero() {
  return (
    <section className="hero-section text-white d-flex align-items-center"
             style={{ minHeight: "100vh", paddingTop: "80px", paddindBottom: "80px" }}>
      <div className="container text-center">
        <h1 className="display-4 fw-bold mb-4">
          Advancing Institutional Healthcare
        </h1>

        <p className="lead mb-5">
          Delivering clinically trusted, regulatory-compliant pharmaceutical
          products to hospitals and healthcare institutions across India.
        </p>

        <div>
          <a href="#contact" className="btn btn-light me-3 px-4 mb-3">
            Request Product Catalog
          </a>
          <a href="#products" className="btn btn-outline-light px-4 mb-3">
            Explore Products
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;